// eslint-disable-next-line no-unused-vars
import api from './api'
import meta from './modules/meta'
import standard from './modules/standard'

export default (resource) => {
  return {
    namespaced: true,
    modules: {
      meta: meta(),
      standard: standard(resource),
    },
    state: {},
    getters: {},
    mutations: {},
    actions: {},
  }
}
